import {
  Box,
  Button,
  Chip,
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
} from "@material-ui/core";
import { InputLabel, TextField } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import {
  getAllRoles,
  getUserByUserName,
  updateApiUser,
} from "../../../Utils/actions";
import { useDispatch, useSelector } from "react-redux";
import FieldCon from "../FieldCon";
import {
  validationLength,
  validationMatch,
  validationMob,
} from "../validationCheck";
import cogoToast from "cogo-toast";
import { useLocation } from "react-router-dom";
import { UndoRounded } from "@mui/icons-material";
import { loadingOn } from "../../../Utils/utils";

const ManageInfo = ({ username }) => {
  const [form, setForm] = useState({
    username: "",
    email: "",
    mobile: "",
    password: "",
    disp_name: "",
    company: "",
    apikey: "",
    fname: "",
    sname: "",
    active_status: "Y",
  });
  const [error, setError] = useState({
    username: "",
    email: "",
    mobile: "",
    password: "",
    disp_name: "",
    company: "",
    apikey: "",
    fname: "",
    sname: "",
    personName: "",
  });
  const [personName, setPersonName] = useState([]);
  const [errorFocus, setErrorFocus] = useState("");
  const dispatch = useDispatch();
  const location = useLocation();
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const { rolesData, userData, allRole } = useSelector((state) => state.data);
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    setForm({ ...form, ...userData });
    setPersonName(userData.roleName);
  }, [userData]);

  useEffect(() => {
    if (isAuthenticated) {
      if (location.pathname === "/manage") {
        dispatch(loadingOn());
        dispatch(getUserByUserName(sessionStorage.getItem("username")));
      } else {
        if (username !== undefined && username !== "") {
          dispatch(loadingOn());
          dispatch(getUserByUserName(username));
        }
      }
      setTimeout(() => {
        dispatch(getAllRoles(10, 0));
      }, 2000);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (!form.username) {
    //   setError({ ...error, username: 'User Name is required' });
    //   return;
    // }
    if (!form.email) {
      setError({ ...error, email: "Email is required" });
      return;
    }
    if (!form.disp_name) {
      setError({ ...error, disp_name: "Display Name is required" });
      return;
    }
    if (!form.fname) {
      setError({ ...error, fname: "First Name is required" });
      return;
    }
    if (!form.sname) {
      setError({ ...error, sname: "SurName is required" });
      return;
    }
    if (!form.company) {
      setError({ ...error, company: "Company is required" });
      return;
    }
    if (!form.mobile) {
      setError({ ...error, mobile: "Mobile is required" });
      return;
    }
    // if (!form.apikey) {
    //   setError({ ...error, apikey: 'Api Key name is required' });
    //   return;
    // }
    if (personName.length === 0) {
      setError({ ...error, personName: "Person name is required" });
      return;
    }
    if (!form.password) {
      setError({ ...error, password: "Password is required" });
      return;
    }
    try {
      form.roleName = personName;
      dispatch(updateApiUser(form));
    } catch (error) {
      cogoToast.error(`User Not successfully ${error}`);
    }
  };

  function getStyles(name, personName) {
    //  personName?.indexOf(name) !== undefined ? {
    if (personName?.indexOf(name) !== undefined) {
      return {
        fontWeight: personName?.indexOf(name) === -1 ? "normal" : "bold",
      };
    }
    // } : null
  }

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const handleChange = async (e) => {
    // e.preventDefault();
    // const { validationLength, validationMatch, validationMob } = await import('../validationCheck');
    if (e.target.name === "personName") {
      setError({ ...error, [e.target.name]: "" });
      setPersonName(
        typeof value === "string" ? e.target.value.split(",") : e.target.value
      );
      return;
    }

    setError({ ...error, [e.target.name]: "" });
    setForm({ ...form, [e.target.name]: e.target.value.toString() });

    try {
      if (e.target.name === "username") {
        await setError({
          ...error,
          username: !validationLength(form.username)
            ? "It has 3-15 character in there "
            : "",
        });
        // setErrorFocus(`<p class=${ ? 'greenColor' : 'redColor'}></p>`)
      }
      if (e.target.name === "email") {
        await setError({
          ...error,
          email: validationLength(form.email)
            ? !validationMatch(form.email, "email")
              ? "There has no special character like (a-z 0-9 @)"
              : ""
            : "It has 3-15 character in there",
        });

        // setErrorFocus(`<p>
        //                     <span class=${validationLength(form.email) ? 'greenColor' : 'redColor'}>1 . It has 3-20 character in there </span> <br/>
        //                     <span class=${? 'greenColor' : 'redColor'}>2 . </span>
        //                   </p>`)
      }
      if (e.target.name === "disp_name") {
        await setError({
          ...error,
          disp_name: validationLength(form.disp_name)
            ? !validationMatch(form.disp_name, "disp_name")
              ? "Valid Display"
              : ""
            : "It has 3-15 character in there",
        });

        // setErrorFocus(`<p>
        //                     <span class=${validationLength(form.disp_name) ? 'greenColor' : 'redColor'}>1 . It has 3-15 character in there </span> <br/>
        //                     <span class=${validationMatch(form.disp_name, "disp_name") ? 'greenColor' : 'redColor'}>2 . Valid Display</span>
        //                   </p>`)
      }
      if (e.target.name === "fname") {
        await setError({
          ...error,
          fname: validationLength(form.fname)
            ? ""
            : "It has 3-15 character in there",
        });
        //  setErrorFocus(`<p>
        //                       <span class=${validationLength(form.fname) ? 'greenColor' : 'redColor'}>1 . It has 3-15 character in there </span>
        //                     </p>`)
      }
      if (e.target.name === "sname") {
        await setError({
          ...error,
          sname: validationLength(form.sname)
            ? ""
            : "It has 3-15 character in there",
        });
        // setErrorFocus(`<p>
        //                       <span class=${validationLength(form.sname) ? 'greenColor' : 'redColor'}>1 . It has 3-15 character in there </span>
        //                     </p>`)
      }
      if (e.target.name === "company") {
        setError({
          ...error,
          company: validationLength(form.company)
            ? ""
            : "It has 3-15 character in there",
        });
        // setErrorFocus(`<p>
        //                     <span class=${validationLength(form.company) ? 'greenColor' : 'redColor'}>1 . It has 3-15 character in there </span>
        //                   </p>`)
      }
      if (e.target.name === "mobile") {
        await setError({
          ...error,
          mobile: validationMob(form.mobile)
            ? ""
            : "Please valid mobile number",
        });
        // setErrorFocus(`<p>
        //                     <span class=${validationMob(form.mobile) ? 'greenColor' : 'redColor'}>1 . It has 10 character in there </span>
        //                   </p>`)
      }
      if (e.target.name === "password") {
        await setError({
          ...error,
          password: validationLength(form.mobile)
            ? !validationMatch(form.password, "password")
              ? "Please make has special character like (A-Z a-z 0-9 $@$!%*?&)"
              : ""
            : "Please valid mobile number",
        });
        // setErrorFocus(`<p>
        //                     <span class=${validationLength(form.password) ? 'greenColor' : 'redColor'}>1 . It has 3-20 character in there </span> <br/>
        //                     <span class=${validationMatch(form.password, "password") ? 'greenColor' : 'redColor'}>2 .  </span>
        //                   </p>`)
      }
    } catch (err) {
      setErrorFocus(err);
    }
  };

  const handleChangesOnFocus = () => {
    setErrorFocus("");
  };

  return (
    // <div style={{ width: "100%" }}>
    //   <div className='col-md-12' style={{ height: "86vh", padding: "15px"}}>
    <Fragment>
      <Card
        className={"shadow-none w-100 manage-info-card"}
        style={{
          backgroundColor: "#333333",
          padding: "15px",
          overflow: "auto",
          height: "89vh",
          border: "none",
          borderRadius: "unset",
        }}
      >
        {/* <Card className='w-100 h-100 mx-auto user-roles shadow-none h-100 border-0' > */}
        {/* <Card.Header className="d-flex justify-content-center align-items-center shadow-none" style={{ border: 'none', backgroundColor: '#286685', color: '#fff' }}><strong>Manage User</strong></Card.Header> */}
        {/* <Card.Header><strong className={"float-left headerName"}>Manage User</strong></Card.Header> */}
        {/* <Card.Body> */}
        <Card.Body
          className={"manageinfo_content"}
          style={{
            borderRadius: "0.25rem",
            background: "#242424",
            overflow: "auto",
            padding: "10px 25px",
          }}
        >
          <Box
            component="form"
            className="addUserBox"
            onSubmit={handleSubmit}
            noValidate
            autoComplete="off"
            style={{ paddingTop: "35px" }}
          >
            {/* <div className='manageinfo col-md-8'> */}
            <div className="d-flex">
              <div className="col-md-4">
                 <style>
                  {`
       .Mui-disabled {
        color: #c7c7c7 !important;
        -webkit-text-fill-color: #c7c7c7 !important; /* for Safari */
      }
      .MuiInputLabel-root.Mui-disabled {
        color: #c7c7c7 !important;
      }
    `}
                    </style>

                <TextField
                  className="input-field"
                  name="username"
                  label="User Name"
                  value={form.username}
                  disabled={true}
                  onFocus={handleChangesOnFocus}
                  required
                  error={!!error.username}
                  helperText={error.username}
                />
              </div>
              <div className="col-md-4">
                <TextField
                  className="input-field"
                  inputMode="email"
                  type="email"
                  name="email"
                  label="Email"
                  onFocus={handleChangesOnFocus}
                  value={form.email}
                  required
                  onChange={handleChange}
                  error={!!error.email}
                  helperText={error.email}
                />
              </div>
            </div>
            <div className="d-flex my-3">
              <div className="col-md-4">
                <TextField
                  className="input-field"
                  name="disp_name"
                  label="Display Name"
                  value={form.disp_name}
                  onFocus={handleChangesOnFocus}
                  required
                  onChange={handleChange}
                  error={!!error.disp_name}
                  helperText={error.disp_name}
                />
              </div>
              <div className="col-md-4">
                <TextField
                  className="input-field"
                  name="company"
                  label="Company"
                  value={form.company}
                  onFocus={handleChangesOnFocus}
                  required
                  onChange={handleChange}
                  error={!!error.company}
                  helperText={error.company}
                />
              </div>
              {/* <div className="col-md-4">
                <TextField
                  className="input-field"
                  name="fname"
                  label="First Name"
                  value={form.fname}
                  onFocus={handleChangesOnFocus}
                  required
                  onChange={handleChange}
                  error={!!error.fname}
                  helperText={error.fname}
                />
              </div> */}
            </div>
            <div className="d-flex my-3">
              {/* <div className="col-md-4">
                <TextField
                  className="input-field"
                  name="sname"
                  label="Last Name"
                  value={form.sname}
                  onFocus={handleChangesOnFocus}
                  required
                  onChange={handleChange}
                  error={!!error.sname}
                  helperText={error.sname}
                />
              </div> */}
              {/* <div className="col-md-4">
                <TextField
                  className="input-field"
                  name="company"
                  label="Company"
                  value={form.company}
                  onFocus={handleChangesOnFocus}
                  required
                  onChange={handleChange}
                  error={!!error.company}
                  helperText={error.company}
                />
              </div> */}
            </div>
            <div className="d-flex my-3">
              <div className="col-md-4">
                <TextField
                  className="input-field"
                  type="number"
                  inputProps={{ maxLength: 10 }}
                  onFocus={handleChangesOnFocus}
                  id="mobile"
                  name="mobile"
                  label="Mobile"
                  required
                  value={form.mobile}
                  onChange={handleChange}
                  error={!!error.mobile}
                  helperText={error.mobile}
                />
              </div>
              <div className="col-md-4">
                <TextField
                  className="input-field"
                  name="apikey"
                  label="Api Key"
                  required
                  value={form.apikey}
                  onFocus={handleChangesOnFocus}
                  disabled={true}
                  error={!!error.apikey}
                  helperText={error.apikey}
                />
              </div>
            </div>
            <div className="d-flex my-3">
              <div className="col-md-4">
                {/* <FormControl sx={{ width: '100%' }} error={!!error.personName} className='formControl-select'>
                        <InputLabel id="demo-multiple-chip-label">Roles Assign</InputLabel>
                        <Select
                          labelId="demo-multiple-chip-label"
                          id="demo-multiple-chip"
                          multiple
                          value={personName}
                          onChange={handleChange}
                          name="personName"
                          input={<OutlinedInput id="select-multiple-chip" label="Roles Assign" />}
                          renderValue={(selected) => (
                            <Box sx={{ display: 'block', flexWrap: 'wrap', gap: 0.5, width: "200px" }}>
                              {selected.length > 0 ? selected.map((value) => (
                                <Chip key={value} label={value.toUpperCase()} />
                              )) : null}
                            </Box>
                          )}

                          MenuProps={MenuProps}
                        >
                          {rolesData.length > 0 ? rolesData.map((name) => (
                            <MenuItem
                              key={name.roleName}
                              value={name.roleName}
                              style={getStyles(name, personName)}
                            >
                              {name.roleName}
                            </MenuItem>
                          )) : null}
                        </Select>
                      </FormControl> */}
                <FormControl
                  sx={{ width: "100%" }}
                  error={!!error.personName}
                  className="formControl-select"
                >
                  <InputLabel
                    id="demo-multiple-chip-label"
                    className="mx-3"
                    style={{
                      color: "#000",
                      // marginTop: "-8px",
                      // marginLeft: "1rem",
                      // marginBottom: "0.3rem",
                      color: "rgba(0, 0, 0, 0.6)",
                      fontSize: "smaller",
                    }} // Set your desired color here
                  >
                    Roles Assign
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-chip-label"
                    id="demo-multiple-chip"
                    multiple
                    value={personName || []}
                    onChange={handleChange}
                    name="personName"
                    className="input-select"
                    input={
                      <OutlinedInput
                        id="select-multiple-chip"
                        label="Roles Assign"
                      />
                    }
                    renderValue={(selected) => (
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 0.5,
                          width: "200px",
                        }}
                      >
                        {selected.length > 0
                          ? selected.map((value) => (
                              <Chip key={value} label={value.toUpperCase()} />
                            ))
                          : null}
                      </Box>
                    )}
                    MenuProps={MenuProps}
                  >
                    {allRole.length > 0
                      ? allRole.map((name) => (
                          <MenuItem
                            key={name.roleName}
                            value={name.roleName}
                            style={getStyles(name, personName)}
                            className="dropdown_vertical"
                          >
                            {name.roleName}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="col-md-2">
              <Button
                type="submit"
                style={{
                 background: 'linear-gradient(135deg, rgb(79, 79, 79), rgb(30, 30, 30))',
                  border: '1px solid rgb(58, 58, 58)',
                  color: "#fff",
                  padding: "8px 25px",
                  marginTop: "7px",
                }}
              >
                Save
              </Button>
            </div>

            {/* <div className='col-md-2'>
                    <FieldCon focus={errorFocus} />
                  </div> */}
            {/* </div> */}
          </Box>
        </Card.Body>
      </Card>
    </Fragment>
    //   </div>
    // </div>
  );
};

export default ManageInfo;
